import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 4px 0 16px 0;
    background: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.OuterBlockRadius};
`;

export const ImageContainer = styled.div`
    height: 184px;
    width: 100%;
    max-width: 100%;
    padding: 0 16px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const Image = styled(LazyLoadImage)`
    height: 184px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
`;

export const Title = styled(H3)<{ isHasTitle: boolean }>`
    align-self: center;
    max-width: 340px;
    height: 64px;
    text-align: center;

    > p {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;

        // Защита, чтобы захардкодить цвет на приходщий с контента
        * {
            color: ${COLORS.TextPrimary} !important;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
        height: ${({ isHasTitle }) => isHasTitle ? '64px' : 'auto'};
    }
`;

export const TopBlock = styled.div`
    flex-direction: column;
    gap: 4px;
`;

export const BottomBlock = styled.div<{ shopItemsCount: number }>`
    flex-direction: column;
    justify-content: flex-end;
    gap: 12px;
    margin-top: ${({ shopItemsCount }) => shopItemsCount > 3 ? '8px' : '20px'};
    padding: 0 16px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        min-height: auto;
    }
`;
